module.exports = "https://static.zego.com/_next/static/images/hero-car-196b045b6a2efe08accc8afea6c1cd31.jpg";